import script from "./PlusStudy.vue?vue&type=script&setup=true&lang=js"
export * from "./PlusStudy.vue?vue&type=script&setup=true&lang=js"

import "./PlusStudy.vue?vue&type=style&index=0&id=5223cfa8&scooped=true&lang=css"

const __exports__ = script;

export default __exports__